import { render, staticRenderFns } from "./SettingsAdmins.vue?vue&type=template&id=276f6cc6&"
import script from "./SettingsAdmins.vue?vue&type=script&lang=js&"
export * from "./SettingsAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports